module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_straight.d6e7bbac.png";